import { logs } from './reducers';
export default logs;
